import { render, staticRenderFns } from "./TimeAssigment.vue?vue&type=template&id=bb85b840&scoped=true&"
import script from "./TimeAssigment.vue?vue&type=script&lang=js&"
export * from "./TimeAssigment.vue?vue&type=script&lang=js&"
import style0 from "./TimeAssigment.vue?vue&type=style&index=0&id=bb85b840&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb85b840",
  null
  
)

export default component.exports